import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var messageApiCalls = {
  fetchMessagesByGroupId: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.groupId.toString();
    },
    types: [ActionTypes.GET_MESSAGESBYGROUPID_REQUEST, ActionTypes.GET_MESSAGESBYGROUPID_SUCCESS, ActionTypes.GET_MESSAGESBYGROUPID_FAILURE, ActionTypes.RESET_GET_MESSAGESBYGROUPID]
  })
};
export default messageApiCalls;